import { render, staticRenderFns } from "./MYHeader.vue?vue&type=template&id=5593a25b&scoped=true"
import script from "./MYHeader.vue?vue&type=script&lang=js"
export * from "./MYHeader.vue?vue&type=script&lang=js"
import style0 from "./MYHeader.vue?vue&type=style&index=0&id=5593a25b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5593a25b",
  null
  
)

export default component.exports